// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, func, string } from 'prop-types'

const buttonClasses = 'btn search-button big-button display-block create-button'

class Import extends React.Component {
  static propTypes = {
    customImportHandler: func.isRequired,
    highlightedRows: array.isRequired,
    idRoot: string.isRequired,
  }

  importHighlightedPaths = () => {
    const {
      customImportHandler,
      highlightedRows,
    } = this.props

    if (!highlightedRows.length) {
      return
    }

    return customImportHandler(highlightedRows)
  }

  render () {
    const {
      highlightedRows,
      idRoot,
    } = this.props

    return (
      <a
        id={`${idRoot}import`}
        className={`${buttonClasses} ${(!highlightedRows.length ? 'cursor-not-allowed bg-grey-dark' : 'bg-blue')}`}
        onClick={this.importHighlightedPaths}>
        {'Import'}
      </a>
    )
  }
}

export default Import
